import { onError } from '@apollo/client/link/error';
import { useAuthSDK } from '~/features/auth-sdk';

// onError link – catch error for refresh tokens
export const errorLink = onError(({ graphQLErrors, response, operation }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      switch (err.extensions?.code) {
        case 'UNAUTHORIZED':
        case 'UNAUTHENTICATED': {
          const { authSDKController } = useAuthSDK();
          authSDKController.refreshTokens(); // Норм?)
          return;
        }
        case 'DOWNSTREAM_SERVICE_ERROR': {
          console.error(err.extensions.code, ':', err.message);
          return;
        }
      }
    }
  }
  return undefined;
});
